import {} from "@mui/material";
import type React from "react";
import type { AdminCargoCreatePageProps } from "../model";
import { CargoCreateInProgress } from "./in-progress";
import { CargoCreatePreview } from "./preview";

export const AdminCargoCreatePageUi: React.FC<AdminCargoCreatePageProps> = (
  props,
) => {
  if (props.previewValues) {
    return <CargoCreatePreview {...props} />;
  }
  return <CargoCreateInProgress {...props} />;
};
